<div class="board-header" *ngIf="!firstLoading">
  <div class="board-bar">

    <div class="board-buttons-block" *ngIf="chosenPricing">
      <button mat-button class="create-order-button" (click)="goBack()">
        <div class="button-title">Back</div>
      </button>
      <ng-container *ngIf="options?.length > 1">
        <input pInputText BlockLateralArrowNavigation type="tel" class="area-name-input-text"
               [(ngModel)]="chosenPricing.name" (keyup)="optionNameUpdate()">
        <button mat-button class="create-order-button option-button" (click)="switchOption(option)"
                *ngFor="let option of options; let i = index"
                [ngClass]="{'selected-option': option.id === chosenPricing.id}">
          <div class="button-title">{{option.name}}
            <p-checkbox [binary]="true" [ngModel]="option.active" [readonly]="option.active"
                        (onChange)="makeActive(option, $event)"></p-checkbox>
            <i class="pi pi-trash" style="font-size: 90%" (click)="deleteOption($event, option, i)"></i>
          </div>
        </button>
      </ng-container>
      <button mat-button class="create-order-button copy-pricing"
              (click)="copyThisPricing(chosenPricing.project.id)" [disabled]="copyPricingLoading"
              [ngClass]="{'disabled-button': copyPricingLoading}">
        <div class="button-title">
          <ng-container *ngIf="!copyPricingLoading">Copy Active Pricing</ng-container>
          <ng-container *ngIf="copyPricingLoading">
            <lib-mini-progress-spinner></lib-mini-progress-spinner>
          </ng-container>
        </div>
      </button>
      <button mat-button class="create-order-button" (click)="getProposal()">
        <div class="button-title">Generate Proposal</div>
      </button>
      <div class="space-block"></div>
      <button mat-button class="create-order-button"
              (click)="openProjectWindow(chosenPricing.project.id)">
        <div class="button-title">{{chosenPricing.project.name}}</div>
      </button>
    </div>

    <ng-container *ngIf="!chosenPricing">
      <div class="project-switch multiselect-block" [ngClass]="{'proj-not-selected': !pricingUsers?.length}">
        <p-multiSelect (onChange)="userChange()" [options]="allUsers" [(ngModel)]="pricingUsers"
                       placeholder="Sales Person" optionLabel="name" [filter]="true" [showToggleAll]="false"
                       filterBy="name"
                       [styleClass]="'project-order-filter'"></p-multiSelect>
      </div>
      <div class="project-switch multiselect-block" [ngClass]="{'proj-not-selected': !pricingCustomer}">
        <p-dropdown (onChange)="customerChange($event)" [options]="pricingCustomers" [(ngModel)]="pricingCustomer"
                    [showClear]="true" placeholder="Customer" optionLabel="name" [filter]="true"
                    filterBy="name"
                    [styleClass]="'project-order-filter'"></p-dropdown>
      </div>
      <div class="project-switch multiselect-block" [ngClass]="{'proj-not-selected': !pricingStatus}">
        <p-dropdown (onChange)="statusChange($event)" [options]="pricingStatuses" [(ngModel)]="pricingStatus"
                    [showClear]="true" placeholder="Status" optionLabel="name" [filter]="true"
                    filterBy="name"
                    [styleClass]="'project-order-filter'"></p-dropdown>

        <p-autoComplete (onSelect)="openProjectPricing($event)" [suggestions]="projects" [(ngModel)]="searchValue"
                        (completeMethod)="filterProjects($event)" field="name" [size]="30" placeholder="Search"
                        [minLength]="1">
        </p-autoComplete>

        <!--        <p-autoComplete (onSelect)="openProjectPricing($event)" [suggestions]="searchPricings" [(ngModel)]="searchValue"-->
        <!--                        field="project.name" [size]="30" placeholder="Search"-->
        <!--                        [minLength]="1" *ngIf="!searchLoading">-->
        <!--        </p-autoComplete>-->
      </div>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="!chosenPricing">
  <div class="pricing-middle" *ngIf="firstLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="pricing-middle" *ngIf="!firstLoading">
    <div class="pricing header-pricing">
      <div class="status-block">
        <div class="status-name">Status</div>
      </div>
      <div class="project-block">
        <div class="project-name">Project</div>
      </div>
      <div class="sales-block">
        <div class="sales">Sales Person</div>
      </div>
      <div class="customer-block">
        <div class="customer-name">Customer</div>
      </div>
      <div class="number-block">
        <div class="number-label">Cabinetry Total</div>
      </div>
      <div class="number-block">
        <div class="number-label">Install</div>
      </div>
      <div class="number-block grand-total-block">
        <div class="number-label grand-label">Grand Total</div>
      </div>
      <div class="space-block">
      </div>
    </div>

    <div class="pricing-block loading-orders-block" *ngIf="pricingLoading">
      <lib-progress-spinner></lib-progress-spinner>
    </div>

    <div class="pricing-block" *ngIf="!pricingLoading">
      <div class="pricing body-pricing" *ngFor="let projPricing of pricings; let i = index"
           (click)="openPricing(projPricing)">
        <div class="status-block">
          <div class="status-name">{{projPricing.status?.name}}</div>
        </div>
        <div class="project-block">
          <div class="project-name">{{projPricing.project?.name}}</div>
        </div>
        <div class="sales-block">
          <div class="sales-name">{{projPricing.createdBy?.name}}</div>
        </div>
        <div class="customer-block">
          <div class="customer-name">{{projPricing.customer?.name}}</div>
        </div>
        <div class="number-block">
          <div class="number-label" *ngIf="projPricing.cabinetryTotal > 0">
            ${{projPricing.cabinetryTotal | number:'1.2-2'}}</div>
        </div>

        <div class="number-block">
          <div class="number-label" *ngIf="projPricing.subtotalInstall > 0">
            ${{projPricing.subtotalInstall | number:'1.2-2'}}</div>
        </div>

        <div class="number-block grand-total-block">
          <div class="number-label grand-label" *ngIf="projPricing.grandTotal > 0">
            ${{projPricing.grandTotal | number:'1.2-2'}}</div>
        </div>

        <div class="space-block">
        </div>

        <div class="delete-block">
          <div class="delete-icon" (click)="deletePricing($event, projPricing, i)"
               *ngIf="deletePricingId !== projPricing.id">
            <i class="pi pi-trash" style="font-size: 135%"></i>
          </div>
          <lib-mini-progress-spinner *ngIf="deletePricingId === projPricing.id"></lib-mini-progress-spinner>
        </div>
      </div>
    </div>

    <div class="paginator-block">
      <p-paginator [rows]="pricingPerPage" [totalRecords]="totalRecords"
                   (onPageChange)="getPricingLazy($event.page, $event.rows)">
      </p-paginator>
    </div>
  </div>
</ng-container>

<router-outlet *ngIf="chosenPricing"></router-outlet>

<p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="item-panel">
</p-confirmDialog>
